import { safelyParseDate } from '@/utils/date';

export const AUTOMATIONS_COLLECTION = 'automations';
export const AUTOMATION_BROKER_STATES_SUBCOLLECTION = 'brokerStates';

export const AUTOMATION_NAMES = {
	preRenewalBasic: 'preRenewalBasic',
	detailedPreRenewal: 'detailedPreRenewal',
	clientInsurancePortfolio: 'clientInsurancePortfolio',
	debtorReminders: 'debtorReminders',
	autoEmailAttachments: 'autoEmailAttachments',
	saveEmailAttachments: 'saveEmailAttachments',
	debtorAutoComplete: 'debtorAutoComplete',
	additionalFolderCreation: 'additionalFolderCreation',
};

export const normalizeAutomationCatalogDoc = (id, data = {}) => {
	return {
		id,
		key: data.key ?? id,
		name: data.name || null,
		title: data.title,
		description: data.description,
		trigger: data.trigger ?? '',
		pipeline: data.pipeline ?? null,
		active: data.active !== false,
		globallyEnabled: data.globallyEnabled === true,
		editable: Boolean(data.editable),
	};
};

export const normalizeAutomationBrokerState = (data = {}) => ({
	enabled: Boolean(data.enabled),
	lastModified: safelyParseDate(data.lastModified)?.getTime() ?? null,
	lastModifiedBy:
		data.lastModifiedBy != null && String(data.lastModifiedBy).trim() !== ''
			? String(data.lastModifiedBy)
			: null,
	lastTriggered: safelyParseDate(data.lastTriggered)?.getTime() ?? null,
	triggerCount: Number(data.triggerCount) || 0,
});

export const mergeBrokerGroupStates = (states = []) => {
	if (states.length === 0) {
		return normalizeAutomationBrokerState({ enabled: false });
	}

	const enabled = states.some((state) => state.enabled);
	const withModified = states
		.filter((state) => state.lastModified != null)
		.sort((a, b) => (b.lastModified ?? 0) - (a.lastModified ?? 0));

	const latest = withModified[0] ?? states[0];

	return normalizeAutomationBrokerState({
		enabled,
		lastModified: latest?.lastModified ?? null,
		lastModifiedBy: latest?.lastModifiedBy ?? null,
		lastTriggered: latest?.lastTriggered ?? null,
		triggerCount: states.reduce((sum, state) => sum + (Number(state.triggerCount) || 0), 0),
	});
};